import { client } from '..';
import { PastorParams } from '../models/pastorsModels';

export const createPastor = async ({
  nonProfitOrgId,
  fullName,
  position,
  annualSalary,
  allowance
}: PastorParams): Promise<any> => {
  const { data } = await client.post('/pastors', {
    fullName,
    position,
    annualSalary,
    allowance,
    nonProfitOrgId
  });
  return data;
};

export const createManyPastors = async (body: { pastors: PastorParams[]; npoId?: string }): Promise<any> => {
  const parsedNonProfitOrgId = body.npoId ? `?npoId=${body.npoId}` : '';

  const { data } = await client.post(`/pastors/replace${parsedNonProfitOrgId}`, { pastors: body.pastors });
  return data;
};
